import React, {useEffect} from 'react';
import '../src/css/login.css';
import {Router} from 'react-router-dom';
import {history} from './helpers/helpers';
import Routes from './routes/routes';
import {MyRuntimeProvider} from './components/RuntimeProvider/MyRuntimeProvider';
import ToastProvider from './components/ToastProvider/ToastProvider';
import DevRoleInfo from './components/DevRoleInfo/DevRoleInfo';
import Clarity from '@microsoft/clarity';
import {NotificationProvider} from './pages/Notifications/context/NotificationContext';

// eslint-disable-next-line require-jsdoc
function App() {
  useEffect(() => {
    Clarity.init('ubyy75v33x');
  }, []);

  return (
    <MyRuntimeProvider>
      <ToastProvider>
        <NotificationProvider>
          <Router history={history}>
            <Routes />
            <DevRoleInfo />
          </Router>
        </NotificationProvider>
      </ToastProvider>
    </MyRuntimeProvider>
  );
}

export default App;
